export const sortItem = {
  joined: ['', 'username_az', 'username_za', 'newest', 'oldest', 'nickname_az', 'nickname_za', 'most_groups_count'],
  'custom-levels': ['most_exp', 'least_exp'],
  'discussion-count': ['most_discussions', 'least_discussions'],
  'best-answer-count': ['most_best_answers', 'least_best_answers'],
  'monthly-comment-count': ['most_monthly_comments', 'least_monthly_comments'],
  'monthly-discussion-count': ['most_monthly_discussions', 'least_monthly_discussions'],
  lastSeen: ['recently_seen', 'least_recently_seen', 'recently_checkin', 'most_total_checkin', 'most_total_continuous_checkin'],
  'comment-count': ['most_comments', 'least_comments'],
  money: ['most_money', 'least_money'],
  likesReceived: ['most_likes_received', 'least_likes_received'],
  badges: ['most_badges_count', 'least_badges_count'],
};
